import { cn } from "@omni/utils/styles";

type Props = {
    title: string;
    price: string | null;
    borderWeight?: number;
    test?: string;
    isTotalPrice?: boolean;
};

const PriceLine = ({
    title,
    price,
    borderWeight = 1,
    test = "priceLine",
    isTotalPrice = false
}: Props) => (
    <>
        {borderWeight > 0 && (
            <hr className={`my-2 border-width-${borderWeight}`} />
        )}
        <div
            data-test={test}
            className={cn("d-flex justify-content-between py-1", {
                "heading-3 font-weight-bold": isTotalPrice
            })}
        >
            <div>{title}</div>
            <div>{price}</div>
        </div>
    </>
);

export default PriceLine;
